export default 'get "/feedback(/*any)" => "feedback#index", as: :feedback';
